module.exports = __webpack_public_path__ + "media/images/login-blue-d0aa3159b5028f610a492e7a1db8a367.svg";